<template>
    <div class="decoration-bg" :class="'decoration-bg--'+ routePath">
        <svg v-if="disp.dashedLine" class="decoration-bg__dashed-line" :class="'decoration-bg__dashed-line--' + routePath" xmlns="http://www.w3.org/2000/svg">
            <use v-bind="{'xlink:href': sprite + '#dashed-line'}" xmlns:xlink="http://www.w3.org/1999/xlink"></use>
        </svg>
        <svg v-if="disp.yellowCircle" class="decoration-bg__yellowCircle" :class="'decoration-bg__yellowCircle--' + routePath" xmlns="http://www.w3.org/2000/svg">
            <use v-bind="{'xlink:href': sprite + '#yellow-circle'}" xmlns:xlink="http://www.w3.org/1999/xlink"></use>
        </svg>
        <svg v-if="disp.twoCircles" class="decoration-bg__twoCircles" :class="'decoration-bg__twoCircles--' + routePath" xmlns="http://www.w3.org/2000/svg">
            <use v-bind="{'xlink:href': sprite + '#two-circles'}" xmlns:xlink="http://www.w3.org/1999/xlink"></use>
        </svg>
    </div>
    

</template>
<script>
export default {
  mounted: function() {
    this.disp = this.chooseItems();
  },
  data: function() {
    return {
      disp: {},
    };
  },
  computed: {
    sprite: function() {
      return require("@/assets/decor-sprite.svg");
    },
  },
  props: {
    routePath: String,
  },
  methods: {
    chooseItems: function() {
      switch (this.routePath) {
        case "home":
          return { dashedLine: true, yellowCircle: true, twoCircles: true };
          break;
        case "about":
          return { dashedLine: false, yellowCircle: true, twoCircles: true };
          break;
        case "menu":
          return { dashedLine: true, yellowCircle: false, twoCircles: false };
          break;
        default:
          return { dashedLine: false, yellowCircle: false, twoCircles: false };
      }
    },
  },
};
</script>
<style lang="scss">
.decoration-bg {
  z-index: 0;

  &--home {
    animation: fade 5.6s;
  }

  &--about {
    animation: fade 4s;
  }

  &__dashed-line,
  &__yellowCircle,
  &__twoCircles {
    position: absolute;
  }

  &__dashed-line {
    stroke: $color-wine;

    &--home {
      top: 35%;
      left: 41%;
      transform: rotate(79.5deg);
    }
  }

  &__yellowCircle {
    &--home {
      height: 40rem;
      width: 40rem;
      top: 0;
      left: 3rem;
    }

    &--about {
      top: 10rem;
      left: -3rem;
    }
  }

  &__twoCircles {
    height: 40rem;
    width: 40rem;
    &--home {
      bottom: -15rem;
      left: -16rem;
    }

    &--about {
      bottom: 10rem;
      left: -20rem;
    }
  }
}
</style>
